import { Card, Row, Col } from 'antd';
import React from 'react';
import Auxiliary from '../../../util/Auxiliary';
import { useManhours } from './data';
import Item from './Item';

const ManhoursStatistic = () => {
  const { loading, manhours } = useManhours();

  return (
    <Auxiliary>
      <Card className="gx-card gx-p-15 gx-text-center" title="Manhours">
        <Row>
          <Col span={6}>
            <Item label={`Daily`} value={manhours.daily} loading={loading} />
          </Col>
          <Col span={6}>
            <Item label={`Weekly`} value={manhours.weekly} loading={loading}  />
          </Col>
          <Col span={6}>
            <Item label={`Monthly`} value={manhours.monthly} loading={loading}  />
          </Col>
          <Col span={6}>
            <Item label={`Yearly/Now`} value={manhours.yearly} loading={loading}  />
          </Col>
        </Row>
      </Card>
    </Auxiliary>
  );
}

export default ManhoursStatistic;